import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import moment from 'moment';
import currencyFormatter from 'currency-formatter';

const baseSelector = state => state.account || fromJS({});
const baseInvoicesSelector = state => state.invoices || fromJS({});

export const addressSelector = createSelector(
    baseSelector,
    account => {
        return fromJS({
            street: account.getIn(['Address', 'Street'], ''),
            postalCode: account.getIn(['Address', 'PostalCode'], ''),
            city: account.getIn(['Address', 'City'], ''),
            companyName: account.getIn(['CompanyName'], ''),
            email: account.getIn(['EmailAddress'], ''),
        });
    }
);

export const invoicesSelector = createSelector(
    baseInvoicesSelector,
    invoices =>
        invoices
            .get('items')
            .valueSeq()
            .map(invoice =>
                fromJS({
                    id: invoice.get('Id'),
                    sendDate: formatDate(invoice.get('SentAt')),
                    dueDate: formatDate(invoice.get('DueDate')),
                    contractId: invoice.get('ContractId'),
                    amount: currencyFormatter.format(invoice.get('TotalGross'), { code: 'EUR' }),
                })
            )
);

const formatText = (text, altText) => {
    if (text !== null && text !== undefined && text !== '') {
        return text;
    } else {
        return altText;
    }
};

const formatDate = (date, altText = '-') => {
    if (date !== null && date !== undefined) {
        return moment(date).format('LL');
    } else {
        return altText;
    }
};
